var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',{staticClass:"page-dashboard"},[_c('rabbey-top-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }